import Container from "./containers/Container";

const EditProfile = {
  Container,
};

export { EditProfile };
